import { render, staticRenderFns } from "./VrRefundForm.vue?vue&type=template&id=d38513a8&scoped=true&"
import script from "./VrRefundForm.vue?vue&type=script&lang=js&"
export * from "./VrRefundForm.vue?vue&type=script&lang=js&"
import style0 from "./VrRefundForm.vue?vue&type=style&index=0&id=d38513a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38513a8",
  null
  
)

export default component.exports